import type { FAQ, QA } from "services/cms/models";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";

import type { ResolvedRichText } from "./richTextResolver";
import richTextResolver from "./richTextResolver";

export type ResolvedQA = {
    question: string;
    answer: ResolvedRichText;
    anchor?: string;
    id: string;
    openByDefault: boolean;
    index?: string;
    type: string;
};

export type ResolvedFAQ = {
    title: string;
    subTitle?: string;
    questions: ResolvedQA[];
    type: ContentTypeCodenames.FAQ;
    codename: string;
    id: string;
};

const faqResolver = (data: FAQ): ResolvedFAQ => {
    return {
        title: data.elements.title.value,
        subTitle: data.elements.subTitle?.value,
        questions: faqQaResolver(data.elements.qas?.linkedItems),
        type: ContentTypeCodenames.FAQ,
        codename: data.system.codename,
        id: data.system.id,
    };
};

export const faqQaResolver = (qas: QA[]): ResolvedQA[] => {
    return (
        qas.map((question: QA) => {
            const resolvedQuestion: ResolvedQA = {
                question: question.elements.question.value,
                anchor: question.elements?.anchor?.value,
                answer: richTextResolver({
                    html: question.elements.answer.value,
                    linkedItems: question.elements.answer.linkedItems,
                }),
                id: question.system.id,
                openByDefault: false,
                type: "qa",
            };
            return resolvedQuestion;
        }) ?? []
    );
};

export default faqResolver;
